import { HOME_SET_VIEW_ROLE } from '@core/constants/actions';
import { HomeViewRole } from '@app/constants/home';

const setHomeViewRole = (viewRole: HomeViewRole) => ({
  type: HOME_SET_VIEW_ROLE,
  viewRole,
});

export default setHomeViewRole;
